import React from 'react';
import type { AppBarHeaderProps } from './app-nav.header.component';
import { AppBarHeader } from './app-nav.header.component';
import { AppBarNav } from './app-nav.nav.component';
import { AppBarNavList } from './app-nav.nav-list.component';

export interface AppBarComponentProps extends AppBarHeaderProps {
  navName?: string;
}

/**
 * An app nav bar that stays at the top of the screen.
 * @param {object} props
 * @prop {string} props.children - child components that are to be displayed in the app bar
 * @prop {number} [props.navHeight] - the height of the nav bar
 * @prop {boolean} [props.enableSkipToContent] - enabling this adds the skip to main content item to the nav bar
 * @prop {AppBarHeaderProps['headerCSS']} [props.headerCSS] - CSS styles applied to AppBarHeader
 * @prop {string} [props.navName] - optional string used for the nav aria-label
 */
export const AppBarComponent = ({
  children,
  navHeight,
  enableSkipToContent,
  headerCSS,
  navName,
}: AppBarComponentProps) => (
  <AppBarHeader
    navHeight={navHeight}
    enableSkipToContent={enableSkipToContent}
    headerCSS={headerCSS}
  >
    <AppBarNav name={navName}>
      <AppBarNavList>{children}</AppBarNavList>
    </AppBarNav>
  </AppBarHeader>
);
